export const PIP_FACTOR = 10; // 0.10 lot * 50 pips = $50  =>  value = lot * 10 * pips

export const fmtUSD = (n, dp = 2) =>
  "$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });

export const fmtPct = (n, dp = 2) => `${Number(n || 0).toFixed(dp)}%`;

export const fmtDatePL = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
};

// result of lot at given pips: lot * 10 * pips
export const pipsToUsd = (lot, pips) => Number(lot || 0) * PIP_FACTOR * Number(pips || 0);

// lot required to hit target profit at tp pips
export const lotForTarget = (targetUsd, tpPips) => {
  if (!tpPips) return 0;
  const raw = targetUsd / (PIP_FACTOR * tpPips);
  return Math.max(0.01, Math.round(raw * 100) / 100);
};

export function computeLot({ capital, targetPct, slPips, tpPips, rr }) {
  const requiredProfit = (Number(capital) * Number(targetPct)) / 100;
  const lot = lotForTarget(requiredProfit, tpPips);
  const profitAtTp = pipsToUsd(lot, tpPips);
  const lossAtSl = pipsToUsd(lot, slPips);
  const realRR = slPips ? Number(tpPips) / Number(slPips) : Number(rr || 1);
  const riskPct = capital ? (lossAtSl / capital) * 100 : 0;
  return {
    requiredProfit: Math.round(requiredProfit * 100) / 100,
    lot,
    profitAtTp: Math.round(profitAtTp * 100) / 100,
    lossAtSl: Math.round(lossAtSl * 100) / 100,
    rr: Math.round(realRR * 100) / 100,
    riskPct: Math.round(riskPct * 100) / 100,
  };
}

export const LOT_TABLE = [
  { lot: 0.01, tp: 5, sl: 5 },
  { lot: 0.02, tp: 10, sl: 10 },
  { lot: 0.05, tp: 25, sl: 25 },
  { lot: 0.1, tp: 50, sl: 50 },
  { lot: 0.2, tp: 100, sl: 100 },
  { lot: 0.5, tp: 250, sl: 250 },
  { lot: 1.0, tp: 500, sl: 500 },
];

export const SESSION_META = {
  1: { label: "TURA 1", sub: "RANO" },
  2: { label: "TURA 2", sub: "PO POŁUDNIU" },
  3: { label: "TURA 3", sub: "WIECZOREM" },
};

export const STATUS_META = {
  not_started: { label: "NIE ROZPOCZĘTO", dot: "#64748b", color: "text-slate-400" },
  in_progress: { label: "W TRAKCIE", dot: "#f59e0b", color: "text-amber-400" },
  profit: { label: "PROFIT", dot: "#10b981", color: "text-emerald-400" },
  loss: { label: "LOSS", dot: "#ef4444", color: "text-red-400" },
  be: { label: "BE", dot: "#e2e8f0", color: "text-slate-200" },
  skipped: { label: "POMINIĘTA", dot: "#a855f7", color: "text-violet-400" },
};

export const DAY_STATUS_META = {
  not_started: { label: "—", color: "text-slate-500" },
  partial: { label: "PARTIAL", color: "text-amber-400" },
  win: { label: "WIN", color: "text-emerald-400" },
  loss: { label: "LOSS", color: "text-red-400" },
  be: { label: "BE", color: "text-slate-200" },
};

export const CHECKLIST_ITEMS = [
  "Sprawdziłem trend",
  "Sprawdziłem HTF",
  "Sprawdziłem setup",
  "Obliczyłem lot",
  "Ustawiłem SL",
  "Ustawiłem TP",
  "Nie przekroczyłem planowanego ryzyka",
  "Nie overtradowałem",
  "Zapisałem wynik",
  "Zrobiłem podsumowanie dnia",
];
